// src/components/LandingPage/Navbar/Navbar.tsx
import NavbarMobile from './NavbarMobile'
import NavbarDesktop from './NavbarDesktop'
import { useIsMobile } from '../../../utils/isMobile'

interface NavbarProps {
  fixedTop: number
  hideScan?: boolean
}

export default function Navbar({ fixedTop, hideScan }: NavbarProps) {
  const isMobile = useIsMobile()
  return isMobile
    ? <NavbarMobile fixedTop={fixedTop} hideScan={hideScan} />
    : <NavbarDesktop fixedTop={fixedTop} hideScan={hideScan} />
}
